// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"d395f064","175":"0cff559a"}[chunkId] + ".chunk.css";
};